<template>
  <div id="editProductMultiple">
    <CCard class="shadow-sm" style="">
      <CCardBody>
        <CRow>
          <CIcon size="2xl" name="cil-basket" class="text-success col-2 col-sm-1 col-lg-1" />
          <CCol col="7" sm="9" md="9" lg="9">
            <select class="custom-select text-dark" v-model="shopObjectId" disabled id="shop-select">
              <option selected>{{ $t('selectshop') }}</option>
              <option v-for="shop in shops" :key="shop.objectId" :value="shop.objectId">
                {{ shop.shopName }} - {{ shop.branchName }}
              </option>
            </select>
          </CCol>
          <div class="col-3 col-sm-2 col-md-2 text-right">
            <CButton block color="light" @click="goback" class="align-items-center" id="back-button">
              <span><i class="fi fi-rr-arrow-left mr-2" style="position: relative; top: 2px;"></i></span>{{ $t('back') }}
            </CButton>
          </div>
        </CRow>
      </CCardBody>
    </CCard>
    <div v-if="isPermission">
      <CCard class="shadow-sm" id="editProductMultipleCard">
        <CCardBody id="editProductMultipleBody" style="padding: 1.55rem">
          <div class="row mb-3">
            <div class="col-md-10 col-sm-9 col-8 d-inline-flex align-items-center">
              <h2 class="font-weight-normal" id="editProductMultipleTitle">
                {{ $t("editProductManagementMulti") }}
              </h2>
            </div>
          </div>
          <!-- <CRow class="mb-2">
            <CCol lg="10">
              <multiselect id="searchcategorySelect" v-model="searchCategory" :options="dataCategory"
                      :search="true" :showLabels="false" :close-on-select="true" :clear-on-select="false"
                      :placeholder="$t('selectCategory')" label="name" track-by="name" @input="setSearch"
                      class="text-dark font-weight-normal" >
              </multiselect>
            </CCol>
            <CCol lg="2">
              <CButton color="success" block @click="setSearch">
                {{ $t("search") }}
              </CButton>
            </CCol>

          </CRow> -->
          <!-- <search-pattern id="editProductMultipleSearchPattern" class="mb-4" :keyword="keyword" :searchBy="searchBy"
            v-on:getSort="setSearch"></search-pattern> -->
          <CRow class="justify-content-between">
            <CCol>
              <h5 id="editProductMultipleProductCount" class="font-weight-normal col-form-label h5">
                {{ $t("product") }} {{ countProduct }} {{ $t("item") }}
              </h5>
            </CCol>
            <CCol class="col-2">
              <div class="btn-group btn-group-toggle row view-list" data-toggle="buttons">
                <CButton v-if="updateList.length > 0" id="editProductMultipleSaveButton" color="warning"
                  @click="confirmSaveProductMultipleModal = true">{{ $t("save") }} ({{ updateList.length }}
                  {{ $t("item") }})</CButton>
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12" lg="9">
              <sortdata id="editProductMultipleSortData" v-on:getSort="setSort" :sort_value="sort_value"
                :sortdata="sortdata" class="mb-3" />
            </CCol>
            <CCol sm="12" lg="3">
              <div class="sort mb-2 pt-1" style="height: 49px;">
                  <multiselect id="searchcategorySelect" v-model="searchCategory" :options="dataCategory"
                        :search="true" :showLabels="false" :close-on-select="true" :clear-on-select="false"
                        :placeholder="$t('selectCategoryInput')" label="name" track-by="name" @input="setSearch"
                        class="text-dark font-weight-normal  align-items-center" 
                        style=" margin-top: 2px;
                              -webkit-box-align: center !important;
                              -ms-flex-align: center !important;
                              align-items: center !important;" >
                  </multiselect>
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12" lg="12">
              <div id="editProductMultipleTableWrapper" class="mb-3" style="overflow-x: auto">
                <DataTable :items="items" :fields="fields" id="editProductMultipleTable" hover border
                  style="white-space: nowrap">
                  <template #head(isOnScreen)>
                    <div class="text-center mt-1">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="selectAllisOnScreen"
                          :checked="isAllOnScreenChecked"
                          @change="toggleAllOnScreen"
                        />
                        <label class="custom-control-label" for="selectAllisOnScreen">
                          {{ $t('isOnScreen') }}
                        </label>
                      </div>
                    </div>
                  </template>
                  <template #head(favorite)>
                    <div class="text-center mt-1">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="selectAllFavorite"
                          :checked="isAllFavoriteChecked"
                          @change="toggleAllFavorite"
                        />
                        <label class="custom-control-label" for="selectAllFavorite">
                          {{ $t('favorite') }}
                        </label>
                      </div>
                    </div>
                  </template>
                <template #head(netTotalIncVAT)>
                  <div class="text-center mt-1">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="selectAllVatType"
                        :checked="isAllVatTypeChecked"
                        @change="toggleAllVatType"
                      />
                      <label class="custom-control-label" for="selectAllVatType">
                        {{ $t('netTotalIncVAT') }}
                      </label>
                    </div>
                  </div>
                </template>
                <template #head(isMenu)>
                  <div class="text-center mt-1">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="selectAllIsMenu"
                        :checked="isAllIsMenuChecked"
                        @change="toggleAllIsMenu"
                      />
                      <label class="custom-control-label" for="selectAllIsMenu">
                        {{ $t('isMenu') }}
                      </label>
                    </div>
                  </div>
                </template>
                  <template #img="{ item, index }">
                    <td class="text-center">
                      <div
                        class="display text-center"
                        style="width: 70px"
                        @dragover.prevent
                        @dragenter="dragOverIndex = index"
                        @dragleave="dragOverIndex = null"
                        @drop="handleDropImage(index, $event)"
                        :class="{ dragover: dragOverIndex === index }"
                      >
                      <div v-if="dragUploadIndex === index" class="drag-spinner"></div>
                        <!-- <div class="display-type" v-if="item.source === 'GRAB'">
                          <CBadge color="light" shape="pill" style="...">
                            <img src="/img/delivery/grab.png" class="rounded-circle" style="width: 20px" />
                          </CBadge>
                        </div> -->
                        <img
                          v-if="item.remoteImagePath"
                          :src="item.remoteImagePath"
                          class="img-fluid rd"
                          @click="getModalImg(item, index)"
                          style="border-radius: 3px"
                          @error="noImgUrl"
                        />
                        <div
                          v-else
                          @click="getModalImg(item, index)"
                          class="image-placeholder"
                          :style="{ 'aspect-ratio': '4 / 3', backgroundColor: getBGColor(item.indexColor), 'border-radius': '3px' }"
                        ></div>
                        <!-- Spinner -->
                        <CSpinner
                          v-if="uploadingImageIndexes.includes(index)"
                          color="success"
                          size="sm"
                          style="position: absolute; top: 6px; left: 6px;"
                        />

                      </div>
                    </td>

                  </template>
                  <template #SKUName="{ item, index }">
                    <td style="padding-left: 15px">
                      <input :id="'skuNameInput_' + index" v-model.number="item.SKUName"
                        @input="updateItem(index, 'SKUName', item.SKUName)" class="form-control" style="width: 240px" />
                    </td>
                  </template>

                  <template #PLUCode="{ item, index }">
                    <td style="padding-left: 10px">
                      <input :id="'pluCodeInput_' + index" v-model="item.ProductPLU.PLUCode" class="form-control"
                        @input="updateItem(index, 'ProductPLU.PLUCode', item.ProductPLU.PLUCode)" style="width: 150px" />
                    </td>
                  </template>
                  <template #category="{ item, index }">
                    <td>
                      <multiselect :id="'categorySelect_' + index" v-model="item.category" :options="categoryList"
                        :search="true" :showLabels="false" :close-on-select="true" :clear-on-select="false"
                        :placeholder="$t('selectCategory')" label="name" track-by="objectId"
                        class="text-dark font-weight-normal" @input="updateItem(index, 'category', item.category)"
                        style="width: 160px">
                      </multiselect>
                    </td>
                  </template>
                  <template #SKUPrice="{ item, index }">
                    <td class="text-right">
                      <input :id="'priceInput_' + index" v-model.number="item.ProductPRU.exceedUc" min="0" type="number"
                        class="form-control" @input="updateItem(index, 'ProductPRU.exceedUc', item.ProductPRU.exceedUc)"
                        style="width: 120px" />
                    </td>
                  </template>
                  <template #stdCost="{ item, index }">
                    <td class="text-center">
                      <input :id="'costInput_' + index" v-model.number="item.stdCost" min="0"
                        @input="updateItem(index, 'stdCost', item.stdCost)" type="number" class="form-control"
                        style="width: 120px" />
                    </td>
                  </template>
                  <template #isOnScreen="{ item, index }">
                    <td class="text-center">
                      <div class="custom-control custom-checkbox" id="productTypeIsOnScreenCheckbox">
                        <input type="checkbox" class="custom-control-input success cursor" v-model="item.isOnScreen"
                          :id="'isOnScreenCheckbox' + index"
                          @input="updateItem(index, 'isOnScreen', !item.isOnScreen)" />
                        <label class="custom-control-label cursor" :for="'isOnScreenCheckbox' + index">
                        </label>
                      </div>
                    </td>
                  </template>
                  <template #favorite="{ item, index }">
                    <td class="text-center">
                      <div class="custom-control custom-checkbox" id="productTypefavoriteCheckbox">
                        <input type="checkbox" class="custom-control-input success cursor" v-model="item.favorite"
                          :id="'favoriteCheckbox' + index" @input="updateItem(index, 'favorite', !item.favorite)" />
                        <label class="custom-control-label cursor" :for="'favoriteCheckbox' + index"></label>
                      </div>
                    </td>
                  </template>
                  <template #netTotalIncVAT="{ item, index }">
                    <td class="text-center">
                      <div class="custom-control custom-checkbox" id="productTypenetTotalIncVAT">
                        <input type="checkbox" class="custom-control-input success cursor" v-model="item.vatType"
                          true-value="V" false-value="N" :id="'netTotalIncVATCheckbox' + index"
                          @input="updateItem(index, 'vatType', item.vatType)" />
                        <label class="custom-control-label cursor" :for="'netTotalIncVATCheckbox' + index"></label>
                      </div>
                    </td>
                  </template>
                  <template #isMenu="{ item, index }">
                    <td class="text-center">
                      <div class="custom-control custom-checkbox" id="productTypeisMenuCheckbox">
                        <input type="checkbox" class="custom-control-input success cursor" v-model="item.ProductPLU.isMenu"
                          :id="'isMenuCheckbox' + index" @input="updateItem(index, 'ProductPLU.isMenu', !item.ProductPLU.isMenu)" />
                        <label class="custom-control-label cursor" :for="'isMenuCheckbox' + index">
                        </label>
                      </div>
                    </td>
                  </template>
                  <template #unit="{ item, index }">
                    <td class="text-center">
                      <multiselect :id="'UnitSelect_' + index" v-model="item.ProductPLU.unit" :options="unitlist" :search="true"
                        :showLabels="false" :close-on-select="true" :clear-on-select="false"
                        :placeholder="$t('selectUnit')" label="name" track-by="name"
                        class="text-dark font-weight-normal" @input="updateItem(index, 'ProductPLU.unit', item.ProductPLU.unit)"
                        style="width: 150px">
                      </multiselect>
                    </td>
                  </template>
                  <template #description="{ item, index }">
                    <td class="text-left">
                      <textarea :id="'desInput_' + index" v-model="item.description" class="form-control"
                        style="width: 400px" rows="1" @input="updateItem(index, 'description', item.description)"
                        :placeholder="$t('fillProductDetail')"></textarea>
                    </td>
                  </template>
                  <template #shelfLife="{ item, index }">
                    <td class="text-center">
                      <input v-model.number="item.shelfLife" type="number" min="0" class="form-control" style="width: 100px"
                        @input="updateItem(index, 'shelfLife', item.shelfLife)" />
                    </td>
                  </template>
                </DataTable>
              </div>
            </CCol>
          </CRow>
          <pagination id="paginationControl" :meta_data="meta_data" v-on:next="handlePageChange">
          </pagination>
        </CCardBody>
      </CCard>
      <CRow>
        <CModal id="deleteModal" color="danger" :show.sync="deleteModal" centered>
          <h4 class="text-center">{{ $t("dialigDeleteProduct") }}</h4>
          <br />
          <h5 class="text-center">{{ $t("confirmDeleteProduct") }}</h5>
          <template #footer>
            <div class="mx-auto">
              <CCol col="12">
                <CButton id="confirmDeleteButton" color="danger" @click="deleteUnit(itemDelete)">
                  {{ $t("submit") }}
                </CButton>
              </CCol>
            </div>
            <div class="mx-auto">
              <CButton id="cancelDeleteButton" color="light" @click="deleteModal = false">
                {{ $t("cancel") }}
              </CButton>
            </div>
          </template>
        </CModal>
      </CRow>
      <CModal :show.sync="confirmSaveProductMultipleModal" id="confirmSaveProductMultipleModal" size="xl"
        title="ยืนยันบันทึกการแก้ไขสินค้า" centered>
        <CCard class="m-0">
          <CCardBody>
            <div>
              <p>{{ $t("product") }} {{ updateList.length }} {{ $t("item") }}</p>
              <table id="updateListProductTable" class="table table-bordered table-hover table-striped cursor">
                <thead>
                  <tr class="font-weight-normal">
                    <th style="width: 5%" class="text-dark font-weight-normal"></th>
                    <th style="width: 15%; padding-left: 15px" class="text-dark font-weight-normal">
                      {{ $t("product") }}
                    </th>
                    <th style="width: 10%; padding-left: 15px" class="text-dark font-weight-normal">
                      {{ $t("pluCode") }}
                    </th>
                    <th style="width: 10%" class="text-dark font-weight-normal">
                      {{ $t("category") }}
                    </th>
                    <th style="width: 10%" class="text-dark font-weight-normal">
                      {{ $t("price") }}
                    </th>
                    <th style="width: 5%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in updateList" :key="index">
                    <td style="width: 5%">
                      <img v-if="item.remoteImagePath" :src="item.remoteImagePath" class="img-fluid rd"
                        style="border-radius: 3px" @error="noImgUrl" />
                      <div v-else class="image-placeholder" :style="{
                        'aspect-ratio': '4 / 3',
                        backgroundColor: getBGColor(item.indexColor),
                        'border-radius': '3px',
                      }"></div>
                    </td>
                    <td style="width: 25%" class="text-dark font-weight-normal">
                      {{ item.SKUName }}
                    </td>
                    <td style="width: 15%" class="text-dark font-weight-normal">
                      {{ item.PLUCode }}
                    </td>
                    <td style="width: 15%" class="text-dark font-weight-normal">
                      {{ item.category.name }}
                    </td>
                    <td style="width: 10%" class="text-dark font-weight-normal">
                      {{ item.ProductPRU.exceedUc }}
                    </td>
                    <td class="text-center">
                      <img :id="'productBOMTableActionIcon' + index" src="/img/trash.png"
                        style="width: 14px; height: 14px; cursor: pointer" @click="conremoveRow(item, index)" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>
        <template #footer>
          <CRow class="col-12 justify-content-center">
            <CCol class="text-center" col="6">
              <CButton color="light" block @click="confirmSaveProductMultipleModal = false">
                {{ $t('cancel') }}
              </CButton>
            </CCol>
            <CCol class="text-center" col="6">
              <CButton v-if="loadingSaveProduct"  color="primary" block disabled>
                <CSpinner  color="white" size="sm" />  {{ $t('save') }}
              </CButton>
              <CButton color="primary" block @click="saveEditProduct()" v-else >
                {{ $t('save') }}
              </CButton>
            </CCol>
          </CRow>
        </template>
      </CModal>
      <CRow>
        <CModal :closeOnBackdrop="false" color="success" :show.sync="selectcolor" :title="$t('selectImg')" centered>
          <div v-if="loadingSaveimg" class="text-center">
            <!-- <CRow>
              <CCol md="1" sm="1" col="2" style="margin: 3px" v-for="item in colorList" :key="item.value"
                :value="item.value">
                <CButton v-if="indexColor === item.value"
                  style="box-shadow: 0 0 5px 5px rgb(163, 222, 194); color: white"
                  :class="{ active: indexColor === item.value }" @click="setindexcolor(item.value)"
                  :style="{ backgroundColor: item.color }">
                  <i class="fi fi-rr-check"></i>
                </CButton>
                <CButton v-else :style="{ backgroundColor: item.color }" :class="{ active: indexColor === item.value }"
                  @click="setindexcolor(item.value)">
                  <CIcon>
                    <i class="fas fa-square fa-2x"></i>
                  </CIcon>
                </CButton>
              </CCol>
            </CRow> -->
            <CRow class="justify-content-center align-items-center m-0">
                <CCol v-for="item in colorList" :key="item.value" class="color-picker-col">
                  <CButton
                    :class="['color-picker-btn', { active: indexColor === item.value }]"
                    :style="{ backgroundColor: item.color }"
                    @click="setindexcolor(item.value)"
                  >
                    <i v-if="indexColor === item.value" class="fi fi-rr-check selected-icon"></i>
                  </CButton>
                </CCol>
            </CRow>
            <hr />
            <div class="row pr-2 pl-2 ">
              
              <div class="col-md-12 col-12 text-left">
                <div class="file-upload-container p-2 pr-4 pl-4 pt-0">
                  <label class="custom-file-label">
                    <input type="file" ref="fileInput" accept="image/*" @change="uploadImage" />
                    <i class="fa fa-upload"></i> {{ $t('selectImgFromPC') }}
                  </label>
                </div>
              </div>
              <!-- <div v-if="imageDataBtn.length > 0" class="col-md-6 col-6 text-right">
                <CButton style="color: red;" @click="removeImage"> <i class="fi fi-rr-trash"></i> {{ $t('deleteImg') }}
                </CButton>
              </div> -->
              <div v-if="imageDataBtn.length > 0" class="col-md-12 text-center mt-4">
                <!-- พื้นที่ drag & drop -->
                <div 
                  class="drop-area"
                  @dragover.prevent
                  @drop="handleDrop"
                >
                  <VueCropper v-if="!isUpload && !imageDataBtn.startsWith('https://firebasestorage')"
                    :key="cropperKey"
                    v-show="imageDataBtn" :guides="true" :aspectRatio="selectedRatio"  :initialAspectRatio="selectedRatio" ref="cropper"
                    :src="imageDataBtn" alt="Source Image" :zoomable="true" :scalable="true"  :style="{ height: cropperHeight + 'px' }" >
                  </VueCropper>
                  <img  v-else :src="imageDataBtn"  class="img-fluid" :style="{ height: cropperHeight + 'px' }" />
                </div>
              </div>
             <!-- 🔳 Crop Ratio Selection -->
             <!-- class="cropper-container" -->
            <div class="text-center p-3" v-if="!isUpload && !imageDataBtn.startsWith('https://firebasestorage')">
              <div class="row align-items-center d-flex">
                <div 
                  class="col-auto flex-grow-1 d-flex justify-content-center"  
                  v-for="(ratio, index) in cropRatios" 
                  :key="index"
                  style="padding-left: 1px; padding-right: 1px;"
                >
                  <CButton 
                    color="dark"
                    class="ratio-btn w-100 text-center"
                    :class="{ active: selectedRatio === ratio.value }"
                    @click="setCropRatio(ratio.value)"
                  >
                    <p class="mb-0 ml-1 mr-1">{{ ratio.label }}</p>
                  </CButton>
                </div>
              </div>

            </div>
            </div>
          </div>
          <div v-else>
            <div class="text-center" width="100%">
              <button class="btn" type="button" disabled style="color: darkcyan">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{ $t('imageUploading') }}...
              </button>
            </div>
          </div>
          <template #footer-wrapper>
            <CRow class="p-4">
              <CCol>
                <CButton block color="success" v-if="loadingSaveimg" @click="savecolorimg">
                  {{ $t('save') }}
                </CButton>
                <CButton block color="success" v-else disabled>
                  {{ $t('save') }}
                </CButton>
              </CCol>
              <CCol>
                <CButton block color="light" @click="cancel">
                  {{ $t('cancel') }}
                </CButton>
              </CCol>
            </CRow>
          </template>
        </CModal>
      </CRow>
    </div>
    <div id="noPermission" v-else>
      <access-data></access-data>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import util from "@/util/util";
import pos from "@/services/local";
import Pagination from "@/containers/Pagination";
import Sortdata from "@/containers/SortData";
import permis from "@/util/permission";
import SearchPattern from "@/containers/SearchPattern";
import Multiselect from "vue-multiselect";
import DataTable from "@/containers/DataTable";
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import mime from '@/util/mime'
import uploadImage from '@/util/uploadImage'

export default {
  components: {
    Pagination,
    Sortdata,
    SearchPattern,
    Multiselect,
    DataTable,
    VueCropper
  },
  data() {
    return {
      loadingSaveProduct: false,
      isEcommercePage: false,
      data: [],
      category: [],
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        items: 0,
        limit: 10,
        itemCount: 0,
      },
      loadingButton: true,
      deleteModal: false,
      actionitem: false,
      sortdata: this.$route.query.sort || "SKUName",
      countProduct: 0,
      sort_value: {
        name: "SKUName",
        updated_at: "updated_at",
        category: "category.name",
        sortByNumMin: "sortByNumMin",
        sortByNumMax: "sortByNumMax",
      },
      showView: this.isEcommercePage
        ? "list"
        : this.$route.query.view || "grid",
      view: "",
      keyword: this.$route.query.keyword || "",
      searchBy: this.$route.query.searchBy || "",
      updateList: [],
      confirmSaveProductMultipleModal: false,
      dataUnit: [],
      selectcolor: false,
      loadingSaveimg: true,
      indexColor: 1,
      selectedIndex: null,
      imageDataBtn: '',
      isUpload: true,
      itemObjectId: '',
      selectedRatio: 1, // ค่าเริ่มต้น 1:1
      cropperKey: 0,
      searchCategory :  "",
      dataCategory : [],
      dragOverIndex: null,
      uploadingImageIndexes: [],
      dragUploadIndex: null,
      originalItem: []
    };
  },
  computed: {
    ...mapGetters(["shops", "users", "date"]),
    cropperHeight() {
      if (window.innerWidth < 480) return 200;
      if (window.innerWidth < 768) return 250;
      return 300; // ค่าเริ่มต้นสำหรับหน้าจอใหญ่
    },
    colorList() {
      let data = []
      for (let i = 0; i < 30; i++) {
          data.push({
          color: util.generateColor(i),
          value: i,
          })
      }
      return data
    },
    cropRatios () {
      return [
        { label: "Freeform", value: "freeform" },
        { label: "1:1", value: "1:1" },
        { label: "3:2", value: "3:2" },
        { label: "4:3", value: "4:3" },
        { label: "16:9", value: "16:9" },
        { label: "Original Ratio", value: "original" }
    ]},
    isPermission() {
      return permis.findPermissionRead("product", '/product');
    },
    isEditData() {
      const value = permis.findPermissionEdit("product", '/product');
      return value; // && this.editItem
    },
    editItem() {
      let shop = this.shops.find((i) => i.objectId === this.shopObjectId);
      return shop.editableItem || false;
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId;
      },
      set(newValue) {
        return this.$store.dispatch("setShop", newValue);
      },
    },
    uid() {
      let shop = this.shops.find((i) => i.objectId === this.shopObjectId);
      return shop.uid;
    },
    sortAttr: {
      get() {
        let sortdata = this.sortdata;
        if (sortdata == "sortByNumMin" || sortdata == "sortByNumMax") {
          sortdata = "SKUPrice";
        }
        return sortdata;
      },
      set(newValue) {
        return newValue;
      },
    },
    itempage() {
      return this.meta_data.current_page * 50 - 50;
    },
    items() {
      let data = this.data;

      let detail = [];
      for (let i = 0; i < data.length; i++) {
        let itemData = data[i];
        // ค้นหา item ใน updateList ที่มี objectId ตรงกัน
        let updatedItem = this.updateList.find(
          (updated) => updated.objectId === itemData.objectId
        );
        // ถ้ามี ใช้ข้อมูลจาก updateList
        if (updatedItem) {
          itemData = { ...updatedItem };
        }

        let onhandQty =
          itemData.skuType === "SV" || itemData.skuType === "BOM"
            ? "non-stock products"
            : itemData.onhandQty !== undefined
              ? itemData.onhandQty
              : 0;

        let PLUCode = itemData.ProductPLU?.PLUCode || "-";
        let img = itemData.remoteImagePath || undefined;
        let unit = itemData.unit !== undefined ? itemData.unit : {};
        let isMenu = itemData.ProductPLU?.isMenu || false;
        let stdCost = itemData.stdCost !== undefined ? itemData.stdCost : 0;
        let description = itemData.description !== undefined ? itemData.description : ""

        detail.push({
          SKUName: itemData.SKUName,
          unit: unit,
          onhandQty: util.convertNumber(onhandQty),
          SKUPrice: itemData.SKUPrice,
          productSKUObjectId: itemData.objectId,
          PLUCode: PLUCode,
          ProductPLU : itemData.ProductPLU,
          category: this.findCategoryNameByObjectId(itemData.category.objectId),
          isOnScreen: itemData.isOnScreen,
          favorite: itemData.favorite,
          skuType: itemData.skuType,
          objectId: itemData.objectId,
          indexColor: itemData.indexColor,
          remoteImagePath: img,
          vatType: itemData.vatType,
          sortPrice: itemData.SKUPrice,
          created_at: itemData.created_at,
          isMenu: isMenu,
          stdCost: stdCost,
          source: itemData.source,
          edited: itemData.edited || false,
          description: description,
          ProductPRU : itemData.ProductPRU,
          shelfLife: Number(itemData.shelfLife) || 0
        });
      }      
      return detail;
    },
    queryparams() {
      return {
        sort: this.sortdata,
        page: this.meta_data.current_page,
        view: this.showView,
        searchBy: this.searchBy,
        keyword: this.keyword,
      };
    },
    filteredItems() {
      if (this.isEcommercePage) {
        return this.items.filter((item) => item.source === "SHOPEE");
      } else {
        return this.items;
      }
    },
    isDeleteData() {
      let path = "/product";
      return permis.findPermissionRemove("product", path);
    },
    categoryList() {
      let data = this.dataCategory;
      let detail = [];
      for (let i = 0; i < data.length; i++) {
        // if (data[i].enabled === true) {
          detail.push({
            id: data[i].id,
            name: data[i].name,
            objectId: data[i].objectId,
          });
        // }
      }
      return detail;
    },
    fields() {
      return [
        {
          key: "img",
          label: this.$i18n.t(""),
          _classes: "text-center font-weight-normal",
          //    _style: 'width:5%;'
        },
        {
          key: "PLUCode",
          label: this.$i18n.t("pluCode"),
          _classes: "text-left font-weight-normal ",
          //    _style: 'width:10%'
        },
        {
          key: "SKUName",
          label: this.$i18n.t("name"),
          _classes: "text-left font-weight-normal",
          //    _style: 'width:30%'
        },
        {
          key: "description",
          label: this.$i18n.t("productDes"),
          _classes: "text-left font-weight-normal ",
        },
        {
          key: "category",
          label: this.$i18n.t("category"),
          _classes: "text-left font-weight-normal",
        },
        {
          key: "unit",
          label: this.$i18n.t("unit"),
          _classes: "text-left font-weight-normal",
        },
        {
          key: "SKUPrice",
          label: this.$i18n.t("price"),
          _classes: "text-left font-weight-normal ",
        },

        {
          key: "stdCost",
          label: this.$i18n.t("cost"),
          _classes: "text-left font-weight-normal ",
        },
        {
            key: "shelfLife",
            label: this.$i18n.t("shelfLife"),
            _classes: "text-left font-weight-normal ",
        },
        {
          key: "isOnScreen",
          label: this.$i18n.t("isOnScreen"),
          _classes: "text-center font-weight-normal ",
        },
        {
          key: "favorite",
          label: this.$i18n.t("favorite"),
          _classes: "text-center font-weight-normal ",
        },
        {
          key: "netTotalIncVAT",
          label: this.$i18n.t("netTotalIncVAT"),
          _classes: "text-center font-weight-normal ",
        },
        {
          key: "isMenu",
          label: this.$i18n.t("isMenu"),
          _classes: "text-center font-weight-normal ",
        },

      ];
    },
    fieldsSelect() {
      return [
        {
          key: "action",
          label: this.$i18n.t(""),
          _classes: "text-center font-weight-normal",
        },
        {
          key: "img",
          label: this.$i18n.t(""),
          _classes: "text-center font-weight-normal",

        },
        {
          key: "SKUName",
          label: this.$i18n.t("name"),
          _classes: "text-left font-weight-normal",
        },
        {
          key: "PLUCode",
          label: this.$i18n.t("pluCode"),
          _classes: "text-left font-weight-normal ",
        },
        {
          key: "category",
          label: this.$i18n.t("category"),
          _classes: "text-left font-weight-normal",
        },
        {
          key: "unit",
          label: this.$i18n.t("unit"),
          _classes: "text-left font-weight-normal",
          //    _style: 'width:15%'
        },
        {
          key: "price",
          label: this.$i18n.t("price"),
          _classes: "text-left font-weight-normal ",
        },
        {
          key: "stdCost",
          label: this.$i18n.t("cost"),
          _classes: "text-left font-weight-normal ",
        },
        {
          key: "isOnScreen",
          label: this.$i18n.t("isOnScreen"),
          _classes: "text-center font-weight-normal ",
        },
        {
          key: "favorite",
          label: this.$i18n.t("favorite"),
          _classes: "text-center font-weight-normal ",
        },
        {
          key: "netTotalIncVAT",
          label: this.$i18n.t("netTotalIncVAT"),
          _classes: "text-center font-weight-normal ",
        },
        {
          key: "isMenu",
          label: this.$i18n.t("isMenu"),
          _classes: "text-center font-weight-normal ",
        },
        {
          key: "description",
          label: this.$i18n.t("productDes"),
          _classes: "text-left font-weight-normal ",
        }
      ];
    },
    unitlist() {
      let data = this.dataUnit;
      let detail = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].enabled === true) {
          detail.push({
            id: data[i].id,
            name: data[i].name,
            objectId: data[i].objectId,
          });
        }
      }
      return detail.sort(util.compare);
    },
    page() {
      return this.$route.query.page || 1;
    },
    queryURL() {
      let searchBy = ''
      let keyword = ''
      
      if(this.searchCategory !== ''){
        searchBy = 'Category.objectId'
        keyword = this.searchCategory.objectId
      }
      return (
        "?sort=" +
        this.sortdata +
        "&page=" +
        this.page +
        "&view=" +
        this.showView +
        "&searchBy=" +
        searchBy +
        "&keyword=" +
        keyword
      );
    },
    isAllOnScreenChecked() {
      return this.items.length > 0 && this.items.every(item => item.isOnScreen);
    },
    isAllFavoriteChecked() {
      return this.items.length > 0 && this.items.every(item => item.favorite);
    },
    isAllVatTypeChecked() {
      return this.items.length > 0 && this.items.every(item => item.vatType === 'V');
    },
    isAllIsMenuChecked() {
      return this.items.length > 0 && this.items.every(item => item.ProductPLU?.isMenu === true);
    }
  },
  created() {
    this.getCategory()
    this.getProduct();
    this.getUnit();
    this.shop = this.shops.find((i) => this.shopObjectId === i.objectId);
  },
  watch: {
  },
  mounted() {

  },
  methods: {
    ...util,
    async handleDropImage(index, event) {
      event.preventDefault();
      event.stopPropagation();

      const files = event.dataTransfer.files;
      if (!files.length) return;

      const file = files[0];
      if (!file.type.startsWith("image/")) {
        alert("กรุณาเลือกเฉพาะไฟล์รูปภาพเท่านั้น");
        return;
      }

      const reader = new FileReader();
      reader.onload = async (e) => {
        this.dragUploadIndex = index; // แสดง spinner
        const base64 = e.target.result;

        try {
          const resized = await this.resizeImage(base64);
          const remoteImagePath = await this.onUploadProductImage(this.items[index].objectId, resized);
          this.$set(this.data[index], 'remoteImagePath', remoteImagePath);
          
          this.updateItem(index, "remoteImagePath", remoteImagePath);

        } catch (error) {
          console.error("Upload failed:", error);
        } finally {
          this.dragUploadIndex = null; // ซ่อน spinner
        }
      };
      reader.readAsDataURL(file);
    },
    handleDrop(event) {
      event.preventDefault();
      event.stopPropagation();
      const file = event.dataTransfer.files[0];

      if (file && file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageDataBtn = e.target.result;
          this.isUpload = false;
          this.isload = true;
          this.$nextTick(() => {
            if (this.$refs.cropper) {
              this.$refs.cropper.replace(this.imageDataBtn);
            }
          });
        };
        reader.readAsDataURL(file);
      } else {
        alert("กรุณาลากไฟล์รูปภาพเท่านั้น");
      }
      // หากต้องการให้ dragover มีเอฟเฟกต์สีขอบให้ใช้ @dragenter และ @dragleave เพื่อเพิ่ม / ลบคลาส dragover
    },
    findCategoryNameByObjectId(targetObjectId) {
      let categoryList = this.dataCategory;
      return categoryList.find(item => item.objectId === targetObjectId) || null
    },
    setCropRatio(value) {      
      if (value === "freeform") {
        this.selectedRatio = NaN; // อัตราส่วนอิสระ
      } else if (value === "original") {
        const imageData = this.$refs.cropper.getImageData();
        this.selectedRatio = imageData.naturalWidth / imageData.naturalHeight; // คงอัตราส่วนเดิม
      } else {
        const [w, h] = value.split(":").map(Number); // แปลงค่า "3:2" -> [3, 2]
        this.selectedRatio = w / h;
      }
      this.cropperKey++;
    },
    setindexcolor(color) { 
      if (this.selectedIndex !== null) {                
          this.data[this.selectedIndex].indexColor = color; // อัปเดตค่า indexColor ใน items
          this.updateItem(this.selectedIndex, 'indexColor', color);
      }
      this.indexColor = color;
      this.selectcolor = false; // ปิด Modal หลังเลือกสี
    },
    getModalImg(item, index) {
      if (item.remoteImagePath && item.remoteImagePath !== '') {
        this.imageData = item.remoteImagePath;
        this.imageDataBtn = item.remoteImagePath;
        this.remoteImagePath = item.remoteImagePath;
        this.$refs.cropper = item.remoteImagePath;
        // ตรวจสอบว่า VueCropper โหลดหรือยัง ก่อนเรียก methods หรือ properties ใน ref
        this.$nextTick(() => {
          if (this.$refs.cropper) {
            this.$refs.cropper.replace(item.remoteImagePath); // อัปเดตรูปภาพที่จะแสดงใน cropper
          }
        });
      }else{
        this.remoteImagePath = '';
        this.imageData = '';
        this.imageDataBtn = '';
        
      }
      this.itemObjectId = item.objectId;
      this.indexColor = item.indexColor;
      this.selectedIndex = index; // เก็บ index ของรายการที่เลือก
      this.selectcolor = true;
    },
    cancel() {
      if (this.remoteImagePath != undefined) {
          this.imageDataBtn = this.remoteImagePath
          this.selectcolor = false
          this.isUpload = true
          this.imageData = this.remoteImagePath
      }
      this.selectcolor = false
      this.isload = false
    },
    goback() {
      
      this.$router.push('/product' + this.queryURL)
    },
    getBGColor(i) {
      return util.generateColor(i)
    },
    saveEditProduct() {
      let data = this.updateList.map((item) => {
        return {
            objectId: item.objectId,
            SKUName: item.SKUName,
            category:  this.findCategoryNameByObjectId(item.category.objectId),
            favorite: item.favorite,
            indexColor: item.indexColor,
            remoteImagePath: item.remoteImagePath, // Assuming img is remoteImagePath
            vatType: item.vatType,
            isOnScreen: item.isOnScreen,
            ProductPRU: item.ProductPRU,
            stdCost : item.stdCost,
            description : item.description,
            shelfLife: Number(item.shelfLife) || 0,
            ProductPLU: {
                objectId: item.ProductPLU.objectId,
                PLUCode: item.ProductPLU.PLUCode,
                id: item.ProductPLU.id,
                name: item.SKUName,
                unit: item.ProductPLU.unit,
                isMenu : item.ProductPLU.isMenu,
            }
          };
      });

      let shopObjectId = this.shopObjectId;
      let headers = { shopObjectId: util.sanitizeShopObjectId(shopObjectId) };
      this.loadingSaveProduct = true
      pos({
        method: "PATCH",
        url: "/api/v3.0/productsku/quick",
        data: data,
        headers: headers,
      })
        .then((res) => {
          this.confirmSaveProductMultipleModal = false;
          this.loadingSaveProduct = false
          // this.getProduct();
          this.goback()
          this.updateList = [];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    conremoveRow: function (item, index) {
      var con = confirm('"' + item.SKUName + '" ' + this.$i18n.t("confirmDeleteProduct"));
      if (con == true) {
        this.updateList.splice(index, 1);
      }
    },
    getCategory() {
      const uid = `${localStorage.getItem("shopsUid")}`;
      const shopObjectId = this.shopObjectId;
      let params = {
        page: 1,
        limit: 1000,
      };
      const headers = {
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      };
      pos
        .get("/api/v1.0/shop/" + uid + "/Category/data/" + shopObjectId, {
          params, headers
        })
        .then((res) => {
          const rows = Array.isArray(res.data.data) ? res.data.data : [];
          this.dataCategory = rows.filter(c => String(c.id) !== '1')
          let data = this.dataCategory;
          for (let i = 0; i < data.length; i++) {
            // if (data[i].enabled === true) {
              if (data[i].id == "0") {
                this.category = {
                  id: data[i].id,
                  name: data[i].name,
                  objectId: data[i].objectId,
                };
              // }
            }
          }
        });
    },
    getUnit() {
      const uid = `${localStorage.getItem("shopsUid")}`;
      let params = { page: 1, limit: 1000 };
      const shopObjectId = this.shopObjectId;
      const headers = {
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
      };
      pos.get("/api/v1.0/uid/" + uid + "/Unit/data", { params, headers })
        .then((res) => {
          this.dataUnit = res.data.data;
        });
    },
    deleteProduct() {
      const uid = `${localStorage.getItem("shopsUid")}`;
      const plan = this.users.currentPlan;
      const shopObjectId = this.shopObjectId;
      let data = {
        shopObjectId: shopObjectId,
        objectId: this.productSKUObjectId,
      };
      const headers = { shopObjectId: util.sanitizeShopObjectId(shopObjectId)};

      pos({
        method: "post",
        url: "/api/v1.0/" + uid + "/ProductSKU/softdelete",
        params: { plan: plan },
        data: data,
        headers: headers,
      })
        .then(
          setTimeout(() => {
            this.deleteModal = false;
          }, 100)
        )
        .catch((error) => {
          console.log(error);
        });
    },
    selectProduct() {
      this.$router.push("/ecommerce/SelectProduct");
    },
    checkStdCost(item) {
      return item.stdCost > item.sortPrice && item.sortPrice > 0;
    },
    toAddProduct() {
      this.$router.push("/product/newAddproduct");
    },
    toImportProduct() {
      this.$router.push("/product/importProduct");
    },
    noImgUrl(event) {
      event.target.src = process.env.VUE_APP_NOIMAGE;
    },
    getChange(value) {
      this.showView = value;
    },
    confirmdelete(item) {
      this.deleteModal = true;
      this.itemDelete = item;
    },
    reset() {
      this.keyword = "";
      this.getProduct();
    },
    productDetail(item) {
      let productSKUObjectId = item.productSKUObjectId;
      this.$store.dispatch("setProductID", productSKUObjectId);
      this.$store.dispatch("getProductSKUDatail");

      this.$router.push({
        name: "ProductDetail",
        params: { productSKUObjectId },
        query: {
          sort: this.sortdata,
          page: this.meta_data.current_page,
          view: this.showView,
        },
      });
    },
    setSort(value) {
      this.sortdata = value;
      this.getProduct();
    },
    setSearch(searchBy, keyword) {
      this.keyword = keyword;
      this.searchBy = searchBy;
      this.getProduct();
    },
    getProduct(page = this.$route.query.page || 1) {
      this.searchLoadingButton = false;
      this.loadingButton = false;
      const uid = `${localStorage.getItem("shopsUid")}`;
      const shopObjectId = this.shopObjectId;
      const headers = { shopObjectId: util.sanitizeShopObjectId(shopObjectId)};

      let sortOrder = "";
      if (this.sortdata == "sortByNumMin") {
        sortOrder = "asc";
      } else if (
        this.sortdata == "sortByNumMax" ||
        this.sortdata == "updated_at"
      ) {
        sortOrder = "desc";
      } else {
        sortOrder = "asc";
      }

      let params = {
        shopObjectId:shopObjectId,
        page: page,
        sortAttr: this.sortAttr,
        sortOrder: sortOrder,
        limit: this.meta_data.limit,
      };
      // Add search attribute.      
      if (this.searchCategory !== null)  {
        // params["searchVal"] = this.keyword;
        params["categoryObjectId"] = this.searchCategory.objectId
      }
      pos({
        url: "/api/v3.0/productsku/quicklist",
        params: params,
        headers: headers,
        method: "GET",
      }).then((res) => {
        
        this.data = res.data.data.map((item) => ({
          ...item,
          edited: false, // รีเซ็ตสถานะการแก้ไข
        }));

        this.originalData = JSON.parse(JSON.stringify(this.data));

        if (res.data.paginate.items == undefined) {
          this.countProduct = 0;
          this.meta_data.items = 0;
        } else {
          this.countProduct = res.data.paginate.items;
          this.meta_data.items = res.data.paginate.items;
        }
        this.meta_data.last_page = res.data.paginate.pageCount;
        this.meta_data.current_page = res.data.paginate.currentPage;
        this.meta_data.itemCount = res.data.paginate.itemCount;
        this.meta_data.limit = res.data.paginate.perPage;
        // this.countlist = res.data.data.length;
        this.searchLoadingButton = true;
        this.loadingButton = true;
      });
    },
    async handlePageChange(newPage) {
      this.getProduct(newPage); // โหลดข้อมูลใหม่
    },
    getDeepValue(obj, path) {
      return path.split(".").reduce((o, p) => (o && o[p] !== undefined ? o[p] : undefined), obj);
    },
    isItemChanged(current, original) {
      const fields = [
        "SKUName",
        "ProductPRU.exceedUc",
        "ProductPLU.PLUCode",
        "ProductPLU.unit.name",
        "ProductPLU.isMenu",
        "category.objectId",
        "stdCost",
        "vatType",
        "description",
        "indexColor",
        "remoteImagePath",
        "isOnScreen",
        "favorite",
        "shelfLife"
      ];
      
      return fields.some(path => {
        const cur = this.getDeepValue(current, path);
        const ori = this.getDeepValue(original, path);
        return cur !== ori;
      });
    },
    updateItem(index, field, value) {
      // if (field === "vatType") {
      //   value = value === "V" ? "N" : "V";
      // }

      this.$set(this.items[index], field, value);
      this.items[index].edited = true;

      const currentItem = this.items[index];
      const originalItem = this.originalData.find(item => item.objectId === currentItem.objectId);
      if (!originalItem) return;

      const hasChanged = this.isItemChanged(currentItem, originalItem);
      const updateIndex = this.updateList.findIndex(item => item.objectId === currentItem.objectId);

      if (hasChanged) {
        if (updateIndex !== -1) {
          this.updateList.splice(updateIndex, 1, { ...currentItem });
        } else {
          this.updateList.push({ ...currentItem });
        }
      } else {
        if (updateIndex !== -1) {
          this.updateList.splice(updateIndex, 1);
        }
      }
    },
    savecolorimg() {
      this.loadingSaveimg = false
      if (this.isload) {
        let cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL()
        this.imageData = cropedImage
        this.getImageURL()
      } else {
        this.imageData = ''
        this.remoteImagePath = ''
        this.selectcolor = false
        this.loadingSaveimg = true
      }
    },
    async resizeImage(base64Str, maxWidth = 650, maxHeight = 500) {
      return new Promise((resolve) => {
        let img = new Image()
        img.src = base64Str
        img.onload = () => {
          let canvas = document.createElement('canvas')
          const MAX_WIDTH = maxWidth
          const MAX_HEIGHT = maxHeight
          let width = img.width
          let height = img.height

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width
              width = MAX_WIDTH
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height
              height = MAX_HEIGHT
            }
          }
          canvas.width = width
          canvas.height = height
          let ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)
          resolve(canvas.toDataURL())
        }
      })
    },
    async getImageURL() {
      let ref = this.itemObjectId
      if (this.$refs.cropper.getCroppedCanvas() === undefined) {
        return
      }

      const getCroppedCanvas = this.$refs.cropper.getCroppedCanvas().toDataURL()
      const resizedImage = await this.resizeImage(getCroppedCanvas)
      let ext = await mime.getExtension(resizedImage)

      if (ext == null) {
        alert('Only Support File Type Is JPEG, PNG')
        this.isload = false
      } else {
        const oldImagePath = this.imagePath
        // await uploadImage.deleteImage2(oldImagePath)
        const imageName = util.generateFilename('.' + ext)
        const ownerUID = `${localStorage.getItem('uid')}`
        const ref = this.itemObjectId
        // const directoryPath = 'resources/' + ownerUID + '/resources/products/' + ref + '/' + imageName

        // this.remoteImagePath = await uploadImage.onUpload(ownerUID, ref, resizedImage, ext)
        const remoteImagePath = await this.onUploadProductImage(this.itemObjectId, resizedImage);
        
        // ตรวจสอบว่า selectedIndex มีค่าหรือไม่
        if (this.selectedIndex !== null && this.items[this.selectedIndex]) {
          this.$set(this.data[this.selectedIndex], 'remoteImagePath', remoteImagePath);
          this.updateItem(this.selectedIndex, 'remoteImagePath', remoteImagePath);
        }
        this.imgTmpPath = remoteImagePath
        this.selectcolor = false
        this.loadingSaveimg = true
      }
    },
    async onUploadProductImage(ref, image) {
      let headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId)};
      let data = { ref, image };
      try {
        const res = await pos({
          method: 'POST',
          url: '/api/v3.0/upload/productimage',
          data,
          headers,
        });
        return res.data.data.publicUrl;
      } catch (error) {
        console.error('เกิดข้อผิดพลาดในการบันทึก:', error);
        return '';
      }
    },
    handleFileUpload(event, index) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.items[index].image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    uploadImage(e) {
      const file = e.target.files[0]

      if (typeof FileReader === 'function') {
        this.dialog = true

        const reader = new FileReader()
        reader.onload = (event) => {
          this.imageDataBtn = event.target.result
          this.$refs.cropper = this.imageData
          this.isUpload = false
          this.isload = true
        }
        reader.readAsDataURL(file)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },
    toggleAllOnScreen() {
      const newValue = !this.isAllOnScreenChecked;
      this.items.forEach((item, index) => {
        this.$set(item, 'isOnScreen', newValue);
        this.updateItem(index, 'isOnScreen', newValue);
      });
    },
    toggleAllFavorite() {
      const newValue = !this.isAllFavoriteChecked;
      this.items.forEach((item, index) => {
        this.$set(item, 'favorite', newValue);
        this.updateItem(index, 'favorite', newValue);
      });
    },
    toggleAllVatType() {
      const newValue = !this.isAllVatTypeChecked;
      const newVat = newValue ? 'V' : 'N';
      this.items.forEach((item, index) => {
        item.vatType = newVat;
        this.updateItem(index, 'vatType', newVat);
      });
    },
    toggleAllIsMenu() {
      const newValue = !this.isAllIsMenuChecked;
      this.items.forEach((item, index) => {
        this.$set(item.ProductPLU, 'isMenu', newValue);
        this.updateItem(index, 'ProductPLU.isMenu', newValue);
      });
    },
  },
};
</script>
<style>
.form-control {
  cursor: pointer;
}

.custom-select {
  cursor: pointer;
}

.form-control:disabled,
.form-control[readonly] {
  cursor: default;
}

.view-list {
  border-radius: 0.2rem;
  background-color: rgba(0, 0, 0, 0.05);
  margin: 1px;
}

.view-icon:active {
  color: #29b289;
  background-color: white;
}

label.btn.form-check-label.col-lg-6.btn-ghost-secondary.view-icon.active {
  background-color: white;
  color: #29b289;
}

.list {
  box-shadow: 0 0 0 1px #e5e5e5;
}

.list:hover {
  box-shadow: 0 12px 40px 0 rgb(0 0 0 / 16%);
  cursor: pointer;
}

.posti {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 1px;
  height: 16px;
  background-color: #dcdce0;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.rd {
  aspect-ratio: 4 / 3;
  object-fit: cover;
}

.btn-reset {
  box-shadow: 0 0 0 1px #e5e5e5;
}

.btn-reset:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.display {
  position: relative;
  text-align: center;
  color: white;
}

.display-type {
  font-size: 16px !important;
  position: absolute;
  top: 3px;
  right: 5px;
}

.display-type-favorite {
  position: absolute;
  bottom: 3px;
  right: 5px;
  font-size: 15px !important;
}

.label-product {
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 16px;
  /* fallback */
  max-height: 32px;
  /* fallback */
  -webkit-line-clamp: 2;
  /* number of lines to show */
  -webkit-box-orient: vertical;
}

.lo-label {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* เพิ่ม ... จุดจุดจุดท้ายสุด */
}

.lo-label-unit {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* เพิ่ม ... จุดจุดจุดท้ายสุด */
}

.unit-label {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: darkslategray;
  text-overflow: ellipsis;
  /* เพิ่ม ... จุดจุดจุดท้ายสุด */
}

.icon-css {
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 4px;
  padding-left: 0px;
}

.limit-2 {
  line-height: 20px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.limit-1 {
  line-height: 20px;
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
/* Container สำหรับ Input File */
.file-upload-container {
  display: flex;
  align-items: center;
  justify-content: left;
}

/* ซ่อน input file */
.file-upload-container input[type="file"] {
  display: none;
}

/* ปรับแต่งปุ่มอัปโหลด */
.custom-file-label {


  /* padding: 10px 20px; */
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 2px; /* ระยะห่างไอคอนกับข้อความ */
  transition: background-color 0.3s;
}

.custom-file-label:hover {
  /* background-color: #218838; */
}

/* ปรับขนาดไอคอน */
.custom-file-label i {
  font-size: 16px;
}
.color-picker-col {
  width: 31px; /* ปรับขนาดของปุ่ม */
  height: 31px;
  display: contents;
  justify-content: center;
  align-items: center;
  padding: 2px;
}

.color-picker-btn {
  /* width: 100%;
  height: 100%; */
  width: 26px; /* ปรับขนาดของปุ่ม */
  height: 26px;
  border-radius: 50%; /* ทำให้เป็นวงกลม */
  border: none;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.color-picker-btn.active {
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2); /* ขอบเงา */
  position: relative;
}

.selected-icon {
  color: white; /* สีของไอคอนถูกเลือก */
  font-size: 14px;
}
.drop-area {
  border: 2px dashed #ccc;
  border-radius: 10px;
  padding: 10px;
  transition: border 0.3s ease;
}

.drop-area.dragover {
  border-color: #29b289;
  background-color: #f9f9f9;
}
.display.dragover {
  border: 2px dashed #29b289;
  background-color: #f3fdfa;
  transition: 0.3s ease;
}
.dragover {
  border: 2px dashed #29b289;
  background-color: #e6f8f0;
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
}

</style>
<style src="../../assets/styles/multiselect.css"></style>
